import React from 'react';

import Cell from './Cell';
import RowMenu from '../RowMenu';

export default function Row({ cols, row, actions, isTotal }) {
  return (
    <tr className="border-b dark:border-gray-700">
      {cols.map((col, index) => {
        if (isTotal && index === 0) {
          return (
            <td key={col.key} className="px-4 py-3">
              <span className="font-semibold text-gray-900 dark:text-white">
                Total:
              </span>
            </td>
          );
        }

        return (
          <Cell
            key={col.key}
            row={row}
            col={col}
            hidden={isTotal && col.type !== 'currency'}
          />
        );
      })}

      {actions.length ? (
        <td className="px-4 py-3 flex items-center justify-end">
          <RowMenu actions={actions} row={row} />
        </td>
      ) : null}
    </tr>
  );
}
